import { useContext, useEffect, useState } from "react";
import { PanelSessionContext } from "../../../components/sessionContext";
import { redirect, useSearchParams } from "react-router-dom";
import { getColors } from "../../../theme";
import { Box, Card, CircularProgress, useTheme } from "@mui/material";
import axios from "axios";
import { addNotification } from "../../global/notificationWrapper";

const ThirdPartyAuthentication = () => {
    const [pending, setPending] = useState(false);
    const [secondFactorRequired, setSecondFactorRequired] = useState(false);

    const sessionPanel = useContext(PanelSessionContext);
    const theme = useTheme();
    const color = getColors(theme.palette.mode);

    const searchParams = useSearchParams()[0];
    const redirectTo = searchParams.get("redirect");
    const challenge = searchParams.get("challenge");

    useEffect(() => {
        if (sessionPanel.logged?.id !== undefined && redirectTo !== null) {
            setTimeout(() => {
                axios.get(process.env.REACT_APP_API_URL + "/authentication/authorizeService", { withCredentials: true }).then(res => {
                    if (res.status == 200 && redirectTo !== null) {
                        console.log("redirecting")
                        window.location.href = redirectTo + "?authorizationCode=" + res.data.response.authorizationCode
                    } else {
                        addNotification({
                            severity: "error",
                            message: "Failed to authorize with third-party service."
                        })
                        console.log(res.data);
                    }
                })
            }, 20)
        }
    }, [sessionPanel.logged])

    return <div style={{ position: "absolute", left: "0", top: "0", width: "100%", height: "100%", zIndex: 1000, background: color.primary[400], display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Card sx={{p: "20px", width: "10rem", display: "flex", alignItems: "center"}}>
            Authorizing
            <CircularProgress size={24} sx={{ml: "1.5rem"}} color="inherit" />
        </Card>
    </div>
}

export default ThirdPartyAuthentication;